
import { ActiveUser } from "@/utils/active-user";
import { ActiveUserSessionInfo } from "@/utils/active-user-session-info";
import Vue from "vue";
export default Vue.extend({
	props: {
		info: {
			type: Array as ()=>ActiveUserSessionInfo[],
			required: true
		},
		user: {
			type: Object as ()=>ActiveUser,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	}
});
